import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { message } from "antd";
import {
  EyeOutlined,
  EyeInvisibleOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import "./Styles/JobsLog-In.css";
import { useLogin } from "../hooks/useAuth";

const Login = () => {
  const navigate = useNavigate();
  //   const fromSignup = localStorage.getItem("fromSignup") === "true";
  const { login, loading } = useLogin();

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!form.email.trim()) {
      message.error("Please enter your email address");
      return false;
    } else if (!emailRegex.test(form.email)) {
      message.error("Please enter a valid email address");
      return false;
    }

    if (!form.password.trim()) {
      message.error("Please enter your password");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      const formData = new FormData();
      formData.append("email", form.email);
      formData.append("password", form.password);

      const response = await login(formData);

      // Check your API's success structure
      if (response.status === true) {
        message.success("Login successful");
        console.log("🧭 Navigating to dashboard...");
        navigate("/jobs/job-admin", { replace: true });
      } else {
        // Handle case where request succeeds but API returns status: false
        const errorMsg = response.message || "Login failed";
        message.error(errorMsg);
      }
    } catch (error) {
      // console.log("💥 Error in handleSubmit:", error);

      // Display user-friendly error messages based on your API structure
      if (error.code === 401 || error.status === 401) {
        // Your API returns 401 with specific message
        message.error(
          error.message ||
            "Invalid credentials. Please check your email and password."
        );
      } else if (error.code === "ERR_NETWORK") {
        message.error(
          "Network error: Please check your internet connection and try again."
        );
      } else if (error.status >= 500) {
        message.error("Server error. Please try again later.");
      } else if (error.status === 403) {
        message.error("You are not authorized to acess this ");
      } else {
        // Fallback to the error message from API or generic message
        message.error(error.message || "Login failed. Please try again.");
      }
    }
  };
  return (
    <div className="job-login-container">
      <div className="job-login-box">
        <p className="job-headtext">Log In</p>
        <p className="job-subtext">Input login credentials</p>

        <form onSubmit={handleSubmit}>
          <label>Email Address</label>
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            required
          />

          <label className="job-label-2">Password</label>
          <div className="job-password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={form.password}
              onChange={handleChange}
              required
            />
            <span
              className="job-toggle-icon"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
            </span>
          </div>

          <p className="/jobs/job-forgot">
            <Link
              to="/jobs/job-auth/reset-password"
              style={{ textDecoration: "none" }}
              className="job-forgot-password"
            >
              Forgot Password?
            </Link>
          </p>

          <button type="submit" className="job-login-btn">
            {loading ? (
              <>
                <LoadingOutlined style={{ marginRight: 8 }} />
                Logging In....
              </>
            ) : (
              "Log In"
            )}
          </button>
        </form>

        <p className="job-login-link">
          Don't have an account?{" "}
          <Link to="/jobs/job-auth/signup" className="job-login-link-2">
            Sign Up
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
